import { PromoCodeSlots } from './promoCodeSlots';
import { HeldPromoCode, RenewalPromoCode } from './renewalPromoCodes';
import { GridSelection } from './types';

/**
 * Codes on the pay-now modal. They start from the renewal codes but only ever reach pricing and the
 * payment; the renewal code endpoints are never called, so the renewal panel is untouched.
 */

/** The basket's packages are fixed, so a code covers a subject only through the package being paid for. */
export const subjectsCoveredInBasket = (coveredPackageIds: number[], selection: GridSelection): number[] =>
  Object.keys(selection)
    .map((key) => Number(key))
    .filter((subjectsId) => coveredPackageIds.indexOf(selection[subjectsId]) !== -1);

/** The modal's codes for listing. Only one carried over from the renewal has an expiry to show. */
export const payNowHeldCodes = (slots: PromoCodeSlots, renewalCodes: RenewalPromoCode[]): HeldPromoCode[] =>
  Object.keys(slots).map((key) => {
    const promoCode = slots[Number(key)];
    const renewal = renewalCodes.find((c) => c.promoCode === promoCode && !!c.dateEnd);

    return { promoCode, dateEnd: renewal ? renewal.dateEnd : null };
  });
